import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-session_detail",
  "use": "icon-session_detail-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-session_detail\"><path d=\"M185.856 513.024c0 38.912 31.232 70.144 70.144 70.144s70.144-31.232 70.144-70.144S294.912 442.88 256 442.88s-70.144 31.232-70.144 70.144zM443.392 513.024c0 38.912 31.232 70.144 70.144 70.144s70.144-31.232 70.144-70.144-31.232-70.144-70.144-70.144-70.144 31.232-70.144 70.144zM700.928 513.024c0 38.912 31.232 70.144 70.144 70.144s70.144-31.232 70.144-70.144-31.232-70.144-70.144-70.144-70.144 31.232-70.144 70.144z\" p-id=\"5964\" fill=\"#00d4ff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/chat/session_detail.svg
// module id = U5HS
// module chunks = 24